import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "react-bootstrap";
import { Button as PrimeButton } from "primereact/button";
import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";

import { SERVICE_LOCATION, GET_UNSUBMITTED_WORKSHEETS_BETWEEN_DATES, UPLOAD_PAPERWORK } from "../constants/endpoints";

import "./../assets/styles/table.css";
import "./../assets/styles/fitter.css";

const UploadPaperwork = (props) => {
    const toast = useRef(null);
    const fileInputRef = useRef(null);

    const { data } = props;
    const userDepot = (data !== undefined && data !== null) ? data.data.userDetails.depot : "";
    const userName = (data !== undefined && data !== null) ? data.data.userDetails.userName : "";

    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [minToDate, setMinToDate] = useState(null);
    const [disableGoButton, setDisableGoButton] = useState(null);
    const [worksheets, setWorksheets] = useState(null);
    const [selectedWorksheets, setselectedWorksheets] = useState(null);
    const [uploadPaperworkData, setUploadPaperworkData] = useState({
        measureId: 0,
        worksheetNo: 0,
        clientName: "",
        siteName: "",
        fitterId: 0,
        fitterName: "",
        fileType: "",
        fileBase64: "",
        fileName: "",
        submissionStatusUpdatedBy: ""
    });
    const [disableUploadPaperworkButton, setDisableUploadPaperworkButton] = useState(true);
    const [showUploadPaperworkDialog, setShowUploadPaperworkDialog] = useState(false);

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    useEffect(() => {
        const currentDate = new Date();
        const previousDate = new Date(currentDate);
        previousDate.setDate(currentDate.getDate() - 2);
        setFromDate(previousDate);
        setToDate(currentDate);
        getWorkSheets(previousDate, currentDate);
        initFilters();
    }, []);

    const handleNullUploadPaperworkData = () => {
        setUploadPaperworkData({
            measureId: 0,
            worksheetNo: 0,
            clientName: "",
            siteName: "",
            fitterId: 0,
            fitterName: "",
            fileType: "",
            fileBase64: "",
            fileName: "",
            submissionStatusUpdatedBy: ""
        });
    }

    const getFormattedDate = (dateToFormat) => {
        const year = dateToFormat.getFullYear();
        const month = String(dateToFormat.getMonth() + 1).padStart(2, "0");
        const day = String(dateToFormat.getDate()).padStart(2, "0");
        const formatedDate = `${year}-${month}-${day}`;
        return formatedDate;
    }

    const getWorkSheets = (selectedFromDate, selectedToDate) => {
        setLoading(true);
        const formatedFromDate = getFormattedDate(selectedFromDate);
        const formatedToDate = getFormattedDate(selectedToDate)
        const requestedData = {
            StartDate: formatedFromDate,
            EndDate: formatedToDate,
            Depot: userDepot
        }
        const endPoint = SERVICE_LOCATION + GET_UNSUBMITTED_WORKSHEETS_BETWEEN_DATES;
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setselectedWorksheets(null);
            if (response.data.isSuccess) {
                const processedData = response.data.data.calledOffWorkSheets;
                setWorksheets(processedData);
            }
            else if (!response.data.isSuccess) {
                setWorksheets(null);
            }
            setDisableUploadPaperworkButton(true);
            setLoading(false);
            handleHideUploadPaperwork();
        }).catch((error) => {
            setLoading(false);
            handleHideUploadPaperwork();
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const handleGo = () => {
        getWorkSheets(fromDate, toDate);
    }

    const handleFromDate = (e) => {
        const dateSelected = e.value;
        setFromDate(dateSelected);
        setMinToDate(dateSelected);
        setToDate(null);
        setDisableGoButton(true);
    }

    const handleToDate = (e) => {
        const dateSelected = e.value;
        setToDate(dateSelected);
        setDisableGoButton(false);
    }

    const handleWorksheetSelection = (e) => {
        setselectedWorksheets(e.value);
        if ((e.value).length === 1) {
            setDisableUploadPaperworkButton(false);
        } else {
            setDisableUploadPaperworkButton(true);
        }
    }

    const handleShowUploadPaperwork = () => {
        setUploadPaperworkData((prev) => (
            {
                ...prev,
                measureId: selectedWorksheets[0].measureId,
                worksheetNo: selectedWorksheets[0].worksheetNo,
                siteName: selectedWorksheets[0].siteName,
                clientName: selectedWorksheets[0].clientName,
                fitterId: selectedWorksheets[0].fitterId,
                fitterName: selectedWorksheets[0].fitterName,
                submissionStatusUpdatedBy: userName
            }
        ));
        setShowUploadPaperworkDialog(true);
    }

    const handleHideUploadPaperwork = () => {
        handleNullUploadPaperworkData();
        setShowUploadPaperworkDialog(false);
    }

    const handleUploadPaperwork = () => {
        if (uploadPaperworkData.fileName === "") {
            toast.current.show({ severity: "error", summary: "Error", detail: "Please choose a file to upload", life: 3000 });
        }
        else {
            setLoading(true);
            const endPoint = SERVICE_LOCATION + UPLOAD_PAPERWORK;
            axios.post(endPoint, uploadPaperworkData, {
                headers: {
                    Authorization: `Bearer ${data.data.token}`,
                },
            })
                .then((response) => {
                    setLoading(false);
                    if (response.data.isSuccess) {
                        getWorkSheets(fromDate, toDate);
                        toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 3000 });
                    }
                    else if (!response.data.isSuccess) {
                        toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
                })
        }
    }

    const uploadPaperworkFooter = (
        <div>
            <PrimeButton label="Cancel" icon="pi pi-times" onClick={handleHideUploadPaperwork} className="p-button-text" />
            <PrimeButton label="Upload" icon="pi pi-check" onClick={handleUploadPaperwork} autoFocus />
        </div>
    )

    const handleFileUpload = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile.type.startsWith("application/pdf") || selectedFile.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onloadend = () => {
                const base64String = reader.result;
                if (base64String !== "") {
                    setUploadPaperworkData((prev) => (
                        {
                            ...prev,
                            fileType: selectedFile.type.startsWith("image/") ? "image" : "pdf",
                            fileBase64: base64String,
                            fileName: selectedFile.name,
                        }
                    ));
                }
            };
        }
        else {
            toast.current.show({ severity: "error", summary: "Error", detail: "Only PDF and Image Files are allowed", life: 5000 });
        }
    };
    //End File upload

    // Search functionality
    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            clientName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            paymentFormRequired: { value: null, matchMode: FilterMatchMode.CONTAINS },
            siteName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            siteAddress: { value: null, matchMode: FilterMatchMode.CONTAINS },
            siteTelNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            plotNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
            plotDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
            worksheetNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureType: { value: null, matchMode: FilterMatchMode.CONTAINS },
            planDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
            crew: { value: null, matchMode: FilterMatchMode.CONTAINS },
            fitterId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            fitterName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            depot: { value: null, matchMode: FilterMatchMode.CONTAINS },
            resourceCode: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue("");
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    // Search functionality Ends here

    const header = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="from-date">From</label>
                    <Calendar id="from-date" name="from-date" value={fromDate} onChange={handleFromDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="to-date">To</label>
                    <Calendar id="to-date" name="to-date" value={toDate} onChange={handleToDate} minDate={minToDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 padt-23">
                    <Button id="go" label="Go" disabled={disableGoButton} onClick={handleGo}>GO</Button>
                </div>
                <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 padt-15">
                    <div className="flex justify-content-end txt-right">
                        <PrimeButton className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }

            <Toast ref={toast} />

            <div className="worksheets-section">
                <div className="row padb-10">
                    <div className="col-3">
                        <h4>Unsubmitted Workcards</h4>
                    </div>
                    <div className="col-9 buttons-right">
                        <div className="padr-10">
                            <Button className="btn-secondary" disabled={disableUploadPaperworkButton} onClick={handleShowUploadPaperwork}>Upload Paperwork</Button>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <DataTable className="font-12" value={worksheets} selection={selectedWorksheets} selectionMode="checkbox"
                            onSelectionChange={handleWorksheetSelection} dataKey="id" paginator rows={10} rowsPerPageOptions={[10, 20, 50]}
                            removableSort sortMode="multiple" filters={filters} header={header} filterDisplay="row"
                            globalFilterFields={["id", "clientAccount", "clientName", "clientAddress", "clientTerms", "paymentFormRequired",
                                "ContractNumber", "specialNotes", "siteRefNumber", "siteName", "siteAddress", "siteTelNo", "systemId", "plotID", "plotNumber", "plotDescription",
                                "worksheetNo", "worksheetCode", "measureId", "measureStatus", "measureQuantity", "measureCode", "measureDescription", "cavityDepth",
                                "measureType", "planDate", "m2", "depot", "depotCode", "resourceCode", "crew", "fitterId", "fitterName", "submissionId",
                                "submissionType", "submissionStatus", "submittedBy", "submittedDate", "submissionStatusUpdatedBy", "isSubmitted"]}
                            scrollable tableStyle={{ minWidth: "100rem" }} emptyMessage="No worksheets availabe for the selected date range.">
                            <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                            <Column field="id" header="Id" className="table-header" hidden></Column>
                            <Column field="clientAccount" header="Client Account" className="table-header" hidden></Column>
                            <Column field="clientName" sortable key="clientName" header="Client Name" filter filterPlaceholder="Search by client name" className="table-header" ></Column>
                            <Column field="clientAddress" header="Client Address" className="table-header" hidden></Column>
                            <Column field="clientTerms" header="Client Terms" className="table-header" hidden></Column>
                            <Column field="paymentFormRequired" header="PaymentForm Required" sortable filter filterPlaceholder="Search by payment form required" className="table-header"></Column>
                            <Column field="contractNumber" header="Contract Number" className="table-header" hidden></Column>
                            <Column field="specialNotes" header="Special Notes" className="table-header" hidden></Column>
                            <Column field="siteRefNumber" header="Site Ref Number" className="table-header" hidden></Column>
                            <Column field="siteName" header="Site Name" sortable filter filterPlaceholder="Search by site name" className="table-header"></Column>
                            <Column field="siteAddress" header="Site Address" sortable filter filterPlaceholder="Search by site address" className="table-header"></Column>
                            <Column field="siteTelNo" header="Site Telephone No" filter filterPlaceholder="Search by telephone" className="table-header"></Column>
                            <Column field="systemId" header="SystemId" className="table-header" hidden></Column>
                            <Column field="plotID" header="Plot ID" className="table-header" hidden></Column>
                            <Column field="plotNumber" header="Plot Number" sortable filter filterPlaceholder="Search by plot number" className="table-header"></Column>
                            <Column field="plotDescription" header="Plot Description" filter filterPlaceholder="Search by plot description" className="table-header"></Column>
                            <Column field="worksheetNo" header="Worksheet No" sortable filter filterPlaceholder="Search by worksheet no" className="table-header"></Column>
                            <Column field="worksheetCode" header="Worksheet Code" filter filterPlaceholder="Search by worksheet code" className="table-header" hidden></Column>
                            <Column field="measureId" header="Measure Id" filter filterPlaceholder="Search by measure id" className="table-header" hidden></Column>
                            <Column field="measureStatus" header="Measure Status" sortable filter filterPlaceholder="Search by measure status" className="table-header"></Column>
                            <Column field="measureQuantity" header="Measure Quantity" className="table-header" hidden></Column>
                            <Column field="measureCode" header="Measure Code" sortable filter filterPlaceholder="Search by measure code" className="table-header"></Column>
                            <Column field="measureDescription" header="Measure Description" filter filterPlaceholder="Search by measure description" className="table-header"></Column>
                            <Column field="cavityDepth" header="Cavity Depth" className="table-header" hidden></Column>
                            <Column field="measureType" header="Measure Type" sortable filter filterPlaceholder="Search by measure type" className="table-header"></Column>
                            <Column field="planDate" header="Planed Date" sortable filter filterPlaceholder="Search by plan date" className="table-header"></Column>
                            <Column field="m2" header="M2" className="table-header" hidden></Column>
                            <Column field="depot" header="Depot" sortable filter filterPlaceholder="Search by depot" className="table-header"></Column>
                            <Column field="depotCode" header="Depot Code" className="table-header" hidden></Column>
                            <Column field="resourceCode" header="Resource Code" className="table-header" hidden></Column>
                            <Column field="crew" header="Crew" sortable filter filterPlaceholder="Search by crew" className="table-header"></Column>
                            <Column field="fitterId" header="FitterId" className="table-header" hidden></Column>
                            <Column field="fitterName" header="Assigne To Fitter" sortable filter filterPlaceholder="Search by crew" className="table-header" hidden></Column>
                        </DataTable>
                    </div>
                </div>
            </div>

            <Dialog header="Upload Paperwork" visible={showUploadPaperworkDialog} style={{ width: "50vw" }} onHide={handleHideUploadPaperwork} footer={uploadPaperworkFooter}>
                <div className="row">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 fitter-feild">
                            <label htmlFor="clientName">Client Name</label>
                            <InputText value={uploadPaperworkData.clientName} id="clientName" className="p-inputtext-sm" disabled />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 fitter-feild">
                            <label htmlFor="siteName">Site Name</label>
                            <InputText value={uploadPaperworkData.siteName} id="siteName" className="p-inputtext-sm" disabled />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 fitter-feild">
                            <label htmlFor="worksheetNo">Worksheet No</label>
                            <InputText value={uploadPaperworkData.worksheetNo} id="worksheetNo" className="p-inputtext-sm" disabled />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 fitter-feild">
                            <label htmlFor="measureId">Measure Id</label>
                            <InputText value={uploadPaperworkData.measureId} id="measureId" className="p-inputtext-sm" disabled />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 fitter-feild">
                            <label htmlFor="fitter">Fitter</label>
                            <InputText value={uploadPaperworkData.fitterName} id="fitter" className="p-inputtext-sm" disabled />
                        </div>
                    </div>

                    <div className="padr-10">
                        <Button className="btn-secondary" onClick={handleFileUpload}>Choose Paperwork</Button>
                        <input ref={fileInputRef} type="file" accept=".pdf, image/*" style={{ display: "none", width: "1024px", height: "768px" }} onChange={handleFileChange} />
                        <label htmlFor="fitter" className="padl-10">{uploadPaperworkData.fileName}</label>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default UploadPaperwork;